import { jsx, jsxs } from "react/jsx-runtime";
import { useClassNameFactory, useColorScheme } from "@contember/react-utils";
import { themeClassName, colorSchemeClassName } from "@contember/utilities";
import { memo } from "react";
import { Stack } from "../Stack/Stack.js";
const EmptyStateContainer = memo(({
  children,
  header,
  className: classNameProp,
  intent,
  componentClassName = "empty-state-container"
}) => {
  const className = useClassNameFactory(componentClassName);
  return /* @__PURE__ */ jsx("div", { className: className(null, [
    ...themeClassName(intent),
    colorSchemeClassName(useColorScheme()),
    classNameProp
  ]), children: /* @__PURE__ */ jsxs(Stack, { gap: "large", children: [
    header && /* @__PURE__ */ jsx("div", { className: className("header"), children: header }),
    children
  ] }) });
});
EmptyStateContainer.displayName = "Interface.EmptyStateContainer";
export {
  EmptyStateContainer
};
//# sourceMappingURL=EmptyStateContainer.js.map
